import { getAuthToken } from '../storage/authStorage'

export function buildApiBaseUrl(apiPath) {
    const baseUrl = localStorage.getItem('serverPath') || process.env.VUE_APP_BASE_URL
    const normalizedApiPath = apiPath ? '/' + String(apiPath).replace(/^\/+/, '') : ''

    if (!baseUrl) {
        return normalizedApiPath
    }

    const normalizedBaseUrl = String(baseUrl).replace(/\/+$/, '')

    return normalizedBaseUrl + normalizedApiPath
}

export function applyBearerAuthHeader(headers, token) {
    if (token) {
        if (typeof headers.set === 'function') {
            headers.set('Authorization', `Bearer ${token}`)
            return
        }

        headers.Authorization = `Bearer ${token}`
        return
    }

    if (typeof headers.delete === 'function') {
        headers.delete('Authorization')
        return
    }

    delete headers.Authorization
}

export function setAxiosAuthHeader(axiosClient, token = getAuthToken()) {
    applyBearerAuthHeader(axiosClient.defaults.headers.common, token)
}

export function installAuthInterceptor(axiosClient, apiPath = null) {
    setAxiosAuthHeader(axiosClient)

    axiosClient.interceptors.request.use((config) => {
        if (apiPath !== null) {
            config.baseURL = buildApiBaseUrl(apiPath)
        }

        config.headers = config.headers || {}
        applyBearerAuthHeader(config.headers, getAuthToken())

        return config
    })
}
